module.exports = __webpack_public_path__ + "static/media/user.14146ac2.svg";